<template>
  <v-list subheader dense class="ma-0 pt-1 pb-0">
    <h3 class="mt-0">Zonas</h3>
    <v-card-text class="pt-1">
      <v-layout wrap>
        <!-- NEIGHBORHOODS -->
        <v-flex xs12 v-if="showMedellinZones">
          <v-autocomplete
            class="LiveFilter__v-select  pr-1"
            :items="neighborhoods"
            v-model="selectedNeighborhoods"
            item-text="name"
            return-object
            dense
            label="Barrio"
            hide-details
            clearable
            autocomplete
            @change="zoneSelected('selectedNeighborhoods')"
            @click:clear="$nextTick(clearFilter)"
            :disabled="disabledZones && zoneSelectedState !== 'selectedNeighborhoods'"/>
        </v-flex>
        <!-- COMMUNES -->
        <v-flex xs12 v-if="showMedellinZones">
          <v-autocomplete
            class="LiveFilter__v-select  pr-1"
            :items="communesAlt"
            v-model="selectedCommunes"
            label="Comuna"
            item-text="name"
            return-object
            dense
            hide-details
            clearable
            @change="zoneSelected('selectedCommunes')"
            @click:clear="$nextTick(clearFilter)"
            :disabled="disabledZones && zoneSelectedState !== 'selectedCommunes'"/>
        </v-flex>
        <!-- QUADRANT -->
        <v-flex xs12>
          <v-autocomplete
            class="LiveFilter__v-select  pr-1"
            :items="quadrants"            
            v-model="selectedQuadrants"
            label="Cuadrante"
            item-text="name"
            return-object
            dense
            hide-details
            clearable
            @change="zoneSelected('selectedQuadrants')"
            @click:clear="$nextTick(clearFilter)"
            :disabled="disabledZones && zoneSelectedState !== 'selectedQuadrants'"/>
        </v-flex>
        <!-- STATION -->
        <v-flex xs12>
          <v-autocomplete
            class="LiveFilter__v-select  pr-1"
            :items="stationsAlt"
            v-model="selectedStations"
            label="Estación"
            item-text="name"
            return-object
            dense
            hide-details
            clearable
            @change="zoneSelected('selectedStations')"
            @click:clear="$nextTick(clearFilter)"
            :disabled="disabledZones && zoneSelectedState !== 'selectedStations'"/>
        </v-flex>
        <!-- DISTRICTS -->
        <v-flex xs12 v-if="showMedellinZones">            
          <v-autocomplete
            class="LiveFilter__v-select  pr-1"
            :items="districts"
            v-model="selectedDistricts"
            label="Distrito"
            item-text="name"
            return-object
            dense
            hide-details
            clearable
            @change="zoneSelected('selectedDistricts')"
            @click:clear="$nextTick(clearFilter)"
            :disabled="disabledZones && zoneSelectedState !== 'selectedDistricts'"/>
        </v-flex>
        <!-- FIREFIGHTERS -->
        <v-flex xs12 v-if="showMedellinZones">            
          <v-autocomplete
            class="LiveFilter__v-select  pr-1"
            :items="firefighters"
            v-model="selectedFirefighters"
            label="Bomberos"
            item-text="name"
            return-object
            dense
            hide-details
            clearable
            @change="zoneSelected('selectedFirefighters')"
            @click:clear="$nextTick(clearFilter)"
            :disabled="disabledZones && zoneSelectedState !== 'selectedFirefighters'"/>
        </v-flex>
        <!-- MUNICIPALITY -->
        <v-flex xs12 v-if="showMedellinZones">            
          <v-autocomplete
            class="LiveFilter__v-select  pr-1"
            :items="municipality"
            v-model="selectedMunicipality"
            label="Municipios"
            item-text="name"
            return-object
            dense
            hide-details
            clearable
            @change="zoneSelected('selectedMunicipality')"
            @click:clear="$nextTick(clearFilter)"
            :disabled="disabledZones && zoneSelectedState !== 'selectedMunicipality'"/>
        </v-flex>

        <v-flex xs12 mt-3 v-if="showBtnApply">
          <v-btn 
            block 
            color="primary" 
            @click.stop="applyFilterHome"
            :loading="filterButtonLoading">
            Aplicar Filtro
          </v-btn>
        </v-flex>

      </v-layout>
    </v-card-text>
  </v-list>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  // const {mapGetters} = createNamespacedHelpers('filters')

  import {queryZonesByType} from '../utils/api'

  import {zoneTypes} from '../utils/scheduleHelpers'

  import {areasMixin} from '../mixins/areasMixin'

  /**
   * Identificador del cuadrante
   * @type {string}
   */
  const QUADRANT = 'quadrant'
  /**
   * Identificador de la estación
   * @type {string}
   */
  const STATION = 'policeStation'
  /**
   * Identificador del distrito de policia
   * @type {string}
   */
  const DISTRICT = 'policeDistrict'

  /**
   * Filtro por zonas para los vehículos
   * @author Manuel Ochoa
   */
  export default {
    name: 'vehicles-filter',
    props: {
      mapref: {
        type: Object
      }
    },
    mixins: [areasMixin],
    data() {
      return {
        selectedFirefighters: [],
        disabledZones: false,
        zoneSelectedState: null,
        zoneTypesMap: null,
        /**
         * Lista de comunas seleccionadas por el Autocomplete
         * @type {Array}
         */
        selectedCommunes: [],
        /**
         * Lista de barrios seleccionados por el Autocomplete
         * @type {Array}
         */
        selectedNeighborhoods: [],
        /**
         * Lista de cuadrantes seleccionados por el Autocomplete
         * @type {Array}
         */
        selectedQuadrants: [],
        /**
         * Lista de estaciones seleccionadas por el Autocomplete
         * @type {Array}
         */
        selectedStations: [],
        /**
         * Lista de distritos seleccionadas por el Autocomplete
         * @type {Array}
         */
        selectedDistricts: [],
        selectedMunicipality: [],
        /**
         * Establece si el autocomplete de cuadrante está cargando información
         * @type {Boolean}
         */
        quadrantLoading: false,
        /**
         * Establece si el autocomplete de estaciones está cargando información
         * @type {Boolean}
         */
        stationLoading: false,
        /**
         * Establece si el autocomplete de distritos está cargando información
         * @type {Boolean}
         */
        districtLoading: false,
        /**
         * Establece si los filtros están cargando información
         * @type {Boolean}
         */
        filterButtonLoading: false
      }
    },
    watch: {
      filterByAZ(newValue) {
        // console.log('filterByAZ', newValue)
        if (!newValue) {
          this.disabledZones = false
          this.zoneSelectedState = null
          this.selectedCommunes = []
          this.selectedNeighborhoods = []
          this.selectedQuadrants = []
          this.selectedStations = []
          this.selectedDistricts = []
          this.selectedFirefighters = []
          this.selectedMunicipality = []
        }
      }
    },
    computed: {
      ...mapGetters({
        firefighters: 'filters/getFirefighters',
        municipality: 'filters/getMunicipality',
        neighborhoods: 'filters/getNeighborhoods',
        communes: 'filters/getComunes',
        quadrants: 'filters/getQuadrants',
        stations: 'filters/getStations',
        districts: 'filters/getDistricts',
        getGalleryQuadrants: 'filters/getGalleryQuadrants',
        getGalleryStations: 'filters/getGalleryStations',
        getGalleryDistricts: 'filters/getGalleryDistricts',
        clientId: 'auth/clientId',
        mapZoneMode: 'auth/mapZoneMode'

      }),
      ...mapGetters([
        'filterByAZ',
        'lastPositionsInit'
      ]),
      showBtnApply() {
        let showBtnApplyState = false
        if (this.zoneSelectedState !== null) showBtnApplyState = true
        return showBtnApplyState
      },
      showMedellinZones() {
        return this.mapZoneMode !== 'gobernacion'
      }
    },
    methods: {
      clearFilter() {
        this.disabledZones = false
        this.zoneSelectedState = null
      },
      zoneSelected(data) {
        this.disabledZones = true
        // console.log('zoneSelected: ', data)
        this.zoneSelectedState = data
        // console.log('applyFilterHome', this[this.zoneSelectedState])
      },
      applyFilterHome() {
        this.clearDataFiltered()
        this.filterButtonLoading = true
        // this.displayFiltersHome(false)
        // this.displayApplyFiltersHome(true)
        const selected = this[this.zoneSelectedState]
        // console.log('applyFilterHome', selected)
        this.addGeostringFilters(selected.geostring)
        // console.log('applyFilterHome', this[this.zoneSelectedState].geostring)
        const typeZone = this.zoneTypesMap.get(selected.type)
        // await loaded
        this.filterByZone({
          geostring: selected.geostring,
          name: selected.name,
          typeZone: typeZone,
          mapRef: this.mapref
        })

        this.filterButtonLoading = false
        // this.disabledZones = false
        // this.zoneSelectedState = null
        // this.selectedCommunes = []
        // this.selectedNeighborhoods = []
        // this.selectedQuadrants = []
        // this.selectedStations = []
        // this.selectedDistricts = []
        // this.selectedMunicipality = []
      },
      /**
       * Maneja el nuevo valor para cada autocomplete
       *
       * Cuando el valor de algun autocomplete cambia, se llama esta funcion, segun el tipo enciende su propio Loader
       * y luego hace la peticion asincrona que retorna los 10 primeros posibles resultados para cada valor y tipo
       *
       * @param value
       * @param zoneType
       */
      querySelections(value, zoneType) {
        switch (zoneType) {
          case QUADRANT:
            this.quadrantLoading = true
            break
          case STATION:
            this.stationLoading = true
            break
          case DISTRICT:
            this.districtLoading = true
            break
          default:
            break
        }
        queryZonesByType(zoneType, value)
          .then(response => {
            switch (zoneType) {
              case QUADRANT:
                this.quadrants = response.data
                this.quadrantLoading = false
                break
              case STATION:
                this.stations = response.data
                this.stationLoading = false
                break
              case DISTRICT:
                this.districts = response.data
                this.districtLoading = false
                break
              default:
                break
            }
          })
      },
      // ...mapActions(['updateZoneFilters']),
      ...mapActions([
        'filterByZone',
        'addFilterTypeHome',
        'displayFiltersHome',
        'displayApplyFiltersHome',
        'clearDataFiltered',
        'addGeostringFilters'
      ]),
      ...mapActions({
        updateZoneFilters: 'filters/updateZoneFilters',
        setQuadrants: 'filters/setQuadrants',
        setStations: 'filters/setStations',
        setDistricts: 'filters/setDistricts'
      })
    },
    mounted() {
      // console.log('MOUNTED', zoneTypes)
      this.zoneTypesMap = new Map(zoneTypes)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/VehiclesFilter.vue